import { render, staticRenderFns } from "./LearningReport.vue?vue&type=template&id=496cfdf3&scoped=true"
import script from "./LearningReport.vue?vue&type=script&lang=js"
export * from "./LearningReport.vue?vue&type=script&lang=js"
import style0 from "./LearningReport.vue?vue&type=style&index=0&id=496cfdf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496cfdf3",
  null
  
)

export default component.exports